import _ from "lodash"

export function compareFilters(filtersA, filtersB) {
    if (!filtersA || !filtersB) {
        return false
    }
    return _.isEqual(filtersA, filtersB)
}